import { Box, BoxProps, Typography } from '@mui/material';
import React from 'react';
import Text, { TextKey } from '../../shared/Text';

export const FormFieldWrapper: React.FC<BoxProps> = (props) => (
  <Box display="flex" justifyContent="center" mt={2} {...props} />
);

export const FormSubmitWrapper: React.FC<BoxProps> = (props) => (
  <Box display="flex" justifyContent="center" mb={3} mt={5} {...props} />
);

export const FormWrapper: React.FC<BoxProps> = (props) => <Box m="auto" width="70%" {...props} />;

export const CenteredErrorMessage: React.FC<{ icon?: React.ElementType; errorMessages?: TextKey[] }> = ({
  icon: Icon,
  errorMessages = [],
  children,
}) => (
  <Box
    display="flex"
    flexDirection="column"
    justifyContent="center"
    alignItems="center"
    height="100vh"
    width="100vw"
    position="relative"
    top="calc(-7vh)"
  >
    {Icon || errorMessages.length > 0 ? (
      <>
        <Icon />
        <Box mt={1} textAlign="center">
          {errorMessages.map((message, index) => (
            <Typography variant="body2" key={index} sx={{ color: '#a2a5af' }}>
              {Text.get(message)}
            </Typography>
          ))}
        </Box>
        {children && children}
      </>
    ) : (
      children
    )}
  </Box>
);

export const SimpleErrorMessage: React.FC<{ errorMessages: TextKey }> = ({ errorMessages }) => {
  return (
    <Box textAlign="center" display="initial">
      <Typography
        variant="subtitle1"
        sx={{ fontSize: '2.1em', lineHeight: 'normal', color: '#424242' }}
        mt={8.5}
        mx={2.5}
      >
        {Text.get(errorMessages)}
      </Typography>
    </Box>
  );
};
